import { LandingPage } from './pages/dashboard/index.js';
import { Login, Logout, Register, AccountVerified, Registered, ResendConfirmation, ConfirmEmail, ForgotPassword, PasswordReset } from './pages/auth/index.js';
import { AdminsList, AdminsCreate, AdminsShow, AdminsEdit, AdminsDelete } from './pages/admins/index.js';
import { BrandsList, BrandsCreate, BrandsShow, BrandsEdit, BrandsDelete } from './pages/brands/index.js';
import { HelpArticlesList, HelpArticlesShow } from './pages/help_articles/index.js';
import { SupportList, SupportCreate, SupportShow, SupportEdit, SupportDelete } from './pages/support/index.js';
import { BillingList, BillingCreate, BillingShow, BillingEdit, BillingDelete } from './pages/billing/index.js';
import { AuthList, AuthCreate, AuthShow, AuthEdit, AuthDelete } from './pages/auth_configs/index.js';
import { FormsList, FormsCreate, FormsShow, FormsEdit, FormsDelete } from './pages/forms/index.js';
import { SurveysList, SurveysCreate, SurveysShow, SurveysEdit, SurveysDelete } from './pages/surveys/index.js';

Translations.langCode = "en";

Routing.routes = {
    "/": LandingPage,
    "/login": Login,
    "/logout": Logout,
    "/register": Register,
    "/registered": Registered,
    "/resend-confirmation": ResendConfirmation,
    "/(\\w+)/confirm-email": ConfirmEmail,
    "/confirm-email": ConfirmEmail,
    "/account-verified": AccountVerified,
    "/forgot-password": ForgotPassword,
    "/password-reset": PasswordReset,
    "/brands": BrandsList,
    "/brands/create": BrandsCreate,
    "/brands/(\\w+)": BrandsShow,
    "/brands/(\\w+)/edit": BrandsEdit,
    "/brands/(\\w+)/delete": BrandsDelete,
    "/support": SupportList,
    "/support/create": SupportCreate,
    "/support/(\\w+)": SupportShow,
    "/support/(\\w+)/edit": SupportEdit,
    "/support/(\\w+)/delete": SupportDelete,
    "/help": HelpArticlesList,
    "/help/(\\w+)": HelpArticlesShow,
    "/admins": AdminsList,
    "/admins/create": AdminsCreate,
    "/admins/(\\w+)": AdminsShow,
    "/admins/(\\w+)/edit": AdminsEdit,
    "/admins/(\\w+)/delete": AdminsDelete,
    "/billing": BillingList,
    "/billing/create": BillingCreate,
    "/billing/(\\w+)": BillingShow,
    "/billing/(\\w+)/edit": BillingEdit,
    "/billing/(\\w+)/delete": BillingDelete,
    "/auth": AuthList,
    "/auth/create": AuthCreate,
    "/auth/(\\w+)": AuthShow,
    "/auth/(\\w+)/edit": AuthEdit,
    "/auth/(\\w+)/delete": AuthDelete,
    "/forms": FormsList,
    "/forms/create": FormsCreate,
    "/forms/(\\w+)": FormsShow,
    "/forms/(\\w+)/edit": FormsEdit,
    "/forms/(\\w+)/delete": FormsDelete,
    "/surveys": SurveysList,
    "/surveys/create": SurveysCreate,
    "/surveys/(\\w+)": SurveysShow,
    "/surveys/(\\w+)/edit": SurveysEdit,
    "/surveys/(\\w+)/delete": SurveysDelete,
};
